import React,{useState} from 'react'
import { MainContainer } from '../../components/Contents/Contents.element'
import LoadingSpinner from '../../ui/LoadingSpinner';
import PageHeader from '../../layout/PageHeader';
import ClubSearchResult from '../../components/ClubLanding/ClubSearch/ClubSearchResult';
import { useLoading } from '../../contexts/LoadingContext';
import ClubSearchFilter from '../../components/ClubLanding/ClubSearch/ClubSearchFilter';
import { useNavigate } from 'react-router-dom';

const ClubsComponent :React.FC<{ toggle: boolean, isSubSidebarOpen: boolean }> = (props) => {
  const { loading } = useLoading();
  const [activeTab, setActiveTab] = useState<string>('player_search');
  const [isPlayerSearchActive, setIsPlayerSearchActive] = useState<boolean>(activeTab === 'player_search');
  const navigate = useNavigate()
  
  return (
    <MainContainer active={props.toggle} isSubSidebarOpen={props.isSubSidebarOpen}
    isPlayerSearchActive={isPlayerSearchActive}
    className='player-search-results main-container player-detail-page'
    >
      <PageHeader title='Clubs' clearPlayerList={true} onClearPlayerListClick={() => {
        navigate('/clubsearch', { state: { fromMenu: true } });
      }} clubResultList/>
      <div className="player-tab-content main-player-container-new">
        <ClubSearchFilter/>
        <ClubSearchResult />
      </div>
      {/* {loading && <LoadingSpinner />} */}
    </MainContainer>
  )
}

export default ClubsComponent